import React from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { NeritFrameworkRoutingHelper } from 'submodules/nerit-framework-ui/common/router/utils/NeritFrameworkRoutingHelper'
import { ContentCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/content/ContentCP'
import styled from 'styled-components'
import { PrivateRouter } from 'app/routers/private/PrivateRouter'
import { DataAnalysisSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/request/DataAnalysisSearchRequestDTO'
import { SCREEN_FILTER_URL_PARAM } from 'submodules/nerit-framework-ui/common/screens/inner/ScreenTypes'
import { SearchMarkersRequestDTO } from 'submodules/nerit-aquatec-sdk/services/map/dtos/requests/SearchMarkersRequestDTO'
import { HistoricChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/HistoricChartRequestDTO'
import { RoutingHelper } from 'config/RoutingHelper'
import { StatisticChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/StatisticChartRequestDTO'
import { GeographicChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/GeographicChartRequestDTO'
import { FieldCorrelationChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/FieldCorrelationChartRequestDTO'
import { MatrixCorrelationChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/MatrixCorrelationChartRequestDTO'
import { LocationCorrelationChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/LocationCorrelationChartRequestDTO'
import { ToxicityIndexChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/ToxicityIndexChartRequestDTO'
import { IQAChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/IQAChartRequestDTO'
import { IETChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/IETChartRequestDTO'

/**
 * Relacao de Links publicos
 *
 * Acessar o dev-test passando ?screenLinks = true
 */
export function ScreenContentDevTestScreenLinks(): JSX.Element {

    const mapDto: SearchMarkersRequestDTO = { fieldCode: 8, samplingCode: 100 }
    const dataAnalysisDto: DataAnalysisSearchRequestDTO = {
        "fieldCodes": [],
        "regulationCode": 110,
        "locationCodes": [100, 101]
    }

    const historicalChartDto: HistoricChartRequestDTO = { fieldCodes: [141], locationCode: 1708, regulationCode: 108 }
    const geographicChartDto: GeographicChartRequestDTO = { fieldCode: 8, locationCodes: [100, 101], regulationCode: 110 }
    const statisticChartDto: StatisticChartRequestDTO = { fieldCode: 8, locationCode: 100, regulationCode: 110 }
    const fieldCorrelationChartDto: FieldCorrelationChartRequestDTO = { fieldCodes: [8, 151], locationCodes: [100], }
    const locationCorrelationChartRequestDTO: LocationCorrelationChartRequestDTO = { fieldCode: 8, locationCodes: [100, 101], }
    const matrixCorrelationChartRequestDTO: MatrixCorrelationChartRequestDTO = { fieldCodes: [8, 459, 281], locationCodes: [1107], }
    const toxicityIndexChartRequestDTO: ToxicityIndexChartRequestDTO = { fieldCodes: [142], locationCodes: [100], regulationCode: 108 }
    const iqaChartRequestDTO: IQAChartRequestDTO = { locationCodes: [100] }
    const ietChartRequestDTO: IETChartRequestDTO = { locationCodes: [100] }

	return (
		<ContentCP overflowVertical={true}>
			<WrapperSCP>

				<div>
					<ButtonCP
						onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.DATA_ANALISYS}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(dataAnalysisDto)}`)}
					>
						Analise de Dados
					</ButtonCP>
					<ButtonCP
						onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.MAP}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(mapDto)}`)}
					>
						Mapa
					</ButtonCP>
				</div>

				<div>
                    <ButtonCP
                        onClick={() => RoutingHelper.goToChartHistorical(historicalChartDto)}
                    >
                        Série Histórica
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.CHART_STATISTIC}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(statisticChartDto)}`)}
                    >
                        Estatística
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.GEOGRAPHIC}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(geographicChartDto)}`)}
                    >
                        Geográfico
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.CORRELATION_FIELDS}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(fieldCorrelationChartDto)}`)}
                    >
                        Correlação de Parametros
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.CORRELATION_MATRIX}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(matrixCorrelationChartRequestDTO)}`)}
                    >
                        Matriz de Correlação
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.CORRELATION_LOCATIONS}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(locationCorrelationChartRequestDTO)}`)}
                    >
                        Correlação de Pontos
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.WATER_CONTAMINATION}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(toxicityIndexChartRequestDTO)}`)}
                    >
                        Contaminação da Água
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.WATER_QUALITY}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(iqaChartRequestDTO)}`)}
                    >
                        Qualidade da Água
                    </ButtonCP>
                    <ButtonCP
                        onClick={() => NeritFrameworkRoutingHelper.historyPush(`${PrivateRouter.IET}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(ietChartRequestDTO)}`)}
                    >
                        IET
                    </ButtonCP>
				</div>
			</WrapperSCP>
		</ContentCP>
	)
}

const WrapperSCP = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;

  button {
    width: 400px;
    margin-top: 20px;
    
    span {
      width: 100%;
    }
  }
`
